import React from 'react';
import Fab from '@mui/material/Fab';
import TuneIcon from '@mui/icons-material/Tune';
import PropTypes from 'prop-types';


const MobileFilterFab = ({ onToggle }) => {
  return (
    <Fab color="primary" aria-label="add" onClick={onToggle} sx={{
      position:'sticky',
      bottom:'3rem',
      alignSelf:'flex-end',
      display: { xs: 'block', sm: 'block', md: 'block', lg:'none' }
    }}>
      <TuneIcon />
    </Fab>
  );
};

MobileFilterFab.propTypes = {
  onToggle: PropTypes.func.isRequired
};

MobileFilterFab.defaultProps = {
  onToggle: () => {
  }
};

export default MobileFilterFab;
export { MobileFilterFab };